import request from "@/utils/request.js";
// 上传附件
export function uploadFile(data) {
    return request({
        url: "/api/com/uploadFile",
        method: "post",
        data,
    });
}
// 上传日志
export function uploadLog(data) {
    return request({
        url: "/api/com/uploadLog",
        method: "post",
        data,
    });
}

// 上报坐标
export function reportLocation(data) {
    return request({
        url: "/api/user/reportLocation",
        method: "post",
        data,
    });
}
// 上报坐标
export function uploadFid(data) {
    return request({
        url: "/api/user/uploadFid",
        method: "post",
        data,
    });
}

// 获取微信sdk
export function getWxJsapiParams(data) {
    return request({
        url: "/api/com/getWxJsapiParams",
        method: "get",
        loading:false,
        data:data,
    });
}
// 获取地址
export function getAreaList(data) {
    return request({
        url: "/api/com/getArea",
        method: "get",
        loading:false,
        data:data,
    });
}
// 直传oss参数
export function getOssParams(data) {
    return request({
        url: "/api/com/ossParams",
        method: "get",
        loading:false,
        data:data,
    });
}

export function setOrder(data) {
    return request({
        url: "/api/sm/setOrder",
        method: "post",
        data,
    });
}
//根据设备码获取商家信息
export function getMerchantInfo(query) {
    return request({
        url: "/api/sm/getMerchantInfo",
        method: "get",
        data:query,
    });
}

//根据支付成功后的订单信息
export function getOrderDetail(query) {
    return request({
        url: "/api/order/detail",
        method: "get",
        data:query,
    });
}

//商家上级
export function parentInfo(data) {
    return request({
        url: "/api/user/parentInfo",
        method: "get",
        data:data,
        loading:false,
    });
}

// 判断订单是否已支付
export function orderIsPay(data) {
    return request({
        url: "/api/order/isPay",
        method: "get",
        data,
    });
}
// 获取协议
export function loadArgument(data) {
    return request({
        url: "/api/index/agreement",
        method: "get",
        data,
    });
}